import classNames from "classnames";
import { format } from "date-fns";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import React, { useEffect, useState } from "react";
import { FaPlus } from "react-icons/fa";
import { FaPencil } from "react-icons/fa6";
import { toast } from "react-toastify";
import AppCard from "../../../components/appCard";
import UpdateAssociate from "../../../components/dashboard/usuarios/atualizaAssociado";
import NewAssociate from "../../../components/dashboard/usuarios/novoAssociado";
import { Api } from "../../../services/api";
import { LargeTablePague } from "../../../styles/primeReactConfig";
import formatDocument from "../../../utils/formatCurrency";

function Associates() {

  const [showCreate, setShowCreate] = useState(false);
  const [showUpdate, setShowUpdate] = useState(false);
  const [associateInfo, setAssociateInfo] = useState([]);
  const [rowInfo, setRowInfo] = useState([])
  const [reload, setReload] = useState(false);
  const [loading, setLoading] = useState(false);
  const [mobile, setMobile] = useState(false);

  function statusBody(e) {
    let type = "bg-slate-300 text-slate-700";;
    let value = "INATIVO"
    if (e.associado_status === true) {
      type = "bg-emerald-300 text-emerald-700";;
      value = "ATIVO"
    }
    return (
            <div className="flex justify-center items-center ">
              <span className={classNames(
                'text-nowrap py-1 px-2 justify-center flex w-auto',
                type
              )}
              >
                <p className="uppercase text-sm font-bold">
                  {value}
                </p>
              </span>
            </div>)
  }

  function updateBody(e) {
    return (
      <Button
        icon={<FaPencil/>}
        rounded
        severity="success"
        onClick={() => { setRowInfo(e); setShowUpdate(true) }}
      />
    )
  }

  useEffect(() => {
    getAssociatesInfo()
  }, [reload])
  useEffect(() => {
    window.addEventListener("resize", ScreenCheck);
    ScreenCheck()
  }, [])

  const ScreenCheck = () => {
    if (window.screen.width <= 480 || window.screen.height <= 480) {
      setMobile(false)
    }
    else {
      setMobile(true)
    }
  }

  async function getAssociatesInfo() {
    setLoading(true)
    try {
      const { data } = await Api.get(`/associados`);
      setAssociateInfo(data);
    } catch (response) {
      if (response.status === 404)
        toast.error("O Cliente não possui usuarios cadastrados")
      if (response.status === 500)
        toast.error("Erro ao acessar informações do usuário");
    }
    finally {
      setLoading(false)
    }
  }

  const associateHeader =
    (
      <div className="w-full flex justify-between" >
        <div >
          <h4 className="text-xl"><b>Usuários</b></h4>
        </div>
        <div >
          <Button
            icon={<FaPlus/>}
            label="Criar novo"
            onClick={() => setShowCreate(true)}
          />
        </div>
      </div>
    )

  return (
    <AppCard className="">
      {showCreate &&
        <NewAssociate
          close={() => setShowCreate(false)}
          reload={() => setReload(prevReload => !prevReload)}
        />}
      {showUpdate &&
        <UpdateAssociate
          close={() => setShowUpdate(false)}
          reload={() => setReload(prevReload => !prevReload)}
          associateInfo={rowInfo}
        />}
      <div className="grid w-full" >
        <DataTable
          loading={loading}
          value={associateInfo}
          scrollable={mobile}
          pt={LargeTablePague}
          breakpoint="480px"
          emptyMessage="Nenhuma associado encontrado. "
          header={associateHeader}
        >
          <Column header="Nome" style={{ minWidth: "8em", wordBreak: "break-word" }} headerStyle={{ minWidth: "8em" }} field="associado_nome" />
          <Column header="Documento" style={{ minWidth: "10em", wordBreak: "break-word" }} headerStyle={{ minWidth: "10em" }} field="associado_documento" body={rowData => formatDocument(rowData.associado_documento)} />
          <Column header="Email" style={{ minWidth: "18em", wordBreak: "break-word" }} headerStyle={{ minWidth: "18em" }} field="associado_email" />
          <Column header="Data criação" style={{ minWidth: "7em", wordBreak: "break-word" }} headerStyle={{ minWidth: "7em" }} field="created_at" body={rowData => format(new Date(rowData.created_at), 'dd/MM/yyyy')} />
          <Column header="Status" style={{ minWidth: "7em", wordBreak: "break-word" }} headerStyle={{ minWidth: "7em" }} field="associado_status" body={statusBody} />
          <Column header="Editar" body={updateBody} />
        </DataTable>
      </div>
    </AppCard>
  )
}

export default Associates;